// src/pages/Residential/Optional/SafetyPlan/SafetyPlanForm.js
import React from "react";

const SafetyPlanForm = ({ formData, handleChange, addWarningSign, removeWarningSign }) => {
    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="safetyPlanAccordion">

                    {/* Step 1 */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#step1"
                            >
                                Step 1: Warning Signs
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm rounded-circle"
                                style={{ width: "32px", height: "32px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#step1Modal"
                            >
                                <i className="ri-information-line"></i>
                            </button>
                        </h2>
                        <div id="step1" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Warning signs that a crisis may be developing
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea
                                        className="form-control"
                                        name="warningSigns"
                                        value={formData.warningSigns || ""}
                                        onChange={handleChange}
                                        rows="6"
                                        style={{ height: "140px" }}
                                    />
                                    <label>List your personal warning signs (thoughts, images, mood, situation, behavior)</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#step2"
                            >
                                Step 2: Internal Coping Strategies
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm rounded-circle"
                                style={{ width: "32px", height: "32px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#step2Modal"
                            >
                                <i className="ri-information-line"></i>
                            </button>
                        </h2>
                        <div id="step2" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Internal coping strategies
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea
                                        className="form-control"
                                        name="internalCoping"
                                        value={formData.internalCoping || ""}
                                        onChange={handleChange}
                                        rows="6"
                                        style={{ height: "140px" }}
                                    />
                                    <label>Things I can do to distract myself without contacting anyone</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#step3"
                            >
                                Step 3: Social Distraction
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm rounded-circle"
                                style={{ width: "32px", height: "32px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#step3Modal"
                            >
                                <i className="ri-information-line"></i>
                            </button>
                        </h2>
                        <div id="step3" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    People and places that provide distraction
                                </small>

                                {(formData.socialDistractions || []).map((item, index) => (
                                    <div key={index} className="card mb-3 p-3 border">
                                        <div className="row g-3 align-items-center">
                                            <div className="col-md-5">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={item.name || ""}
                                                        onChange={(e) => handleChange(e, "socialDistractions", index, "name")}
                                                    />
                                                    <label>Person / Place Name</label>
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={item.contact || ""}
                                                        onChange={(e) => handleChange(e, "socialDistractions", index, "contact")}
                                                    />
                                                    <label>Contact / Location</label>
                                                </div>
                                            </div>
                                            <div className="col-md-2 text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => removeWarningSign("socialDistractions", index)}
                                                >
                                                    <i className="ri-delete-bin-line"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={() => addWarningSign("socialDistractions")}
                                >
                                    <i className="ri-add-line me-1"></i> Add Person or Place
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#step4"
                            >
                                Step 4: People I Can Ask for Help
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm rounded-circle"
                                style={{ width: "32px", height: "32px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#step4Modal"
                            >
                                <i className="ri-information-line"></i>
                            </button>
                        </h2>
                        <div id="step4" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    People whom I can ask for help
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea
                                        className="form-control"
                                        name="peopleHelp"
                                        value={formData.peopleHelp || ""}
                                        onChange={handleChange}
                                        rows="6"
                                        style={{ height: "140px" }}
                                    />
                                    <label>List names and contact details of supportive people</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#step5"
                            >
                                Step 5: Professional Help
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm rounded-circle"
                                style={{ width: "32px", height: "32px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#step5Modal"
                            >
                                <i className="ri-information-line"></i>
                            </button>
                        </h2>
                        <div id="step5" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Professionals or agencies I can contact during a crisis
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea
                                        className="form-control"
                                        name="professionals"
                                        value={formData.professionals || ""}
                                        onChange={handleChange}
                                        rows="6"
                                        style={{ height: "140px" }}
                                    />
                                    <label>List names, numbers, and locations (e.g., psychiatrist, crisis line)</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#step6"
                            >
                                Step 6: Safe Environment
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm rounded-circle"
                                style={{ width: "32px", height: "32px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#step6Modal"
                            >
                                <i className="ri-information-line"></i>
                            </button>
                        </h2>
                        <div id="step6" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Making my environment safe
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea
                                        className="form-control"
                                        name="safeEnvironment"
                                        value={formData.safeEnvironment || ""}
                                        onChange={handleChange}
                                        rows="6"
                                        style={{ height: "140px" }}
                                    />
                                    <label>Ways I can restrict access to lethal means or make surroundings safer</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Reason for Living */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button
                                className="accordion-button fw-semibold collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#reasonLiving"
                            >
                                My Reason for Living
                            </button>
                        </h2>
                        <div id="reasonLiving" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    The one thing that is most important to me and worth living for is:
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea
                                        className="form-control"
                                        name="reasonLiving"
                                        value={formData.reasonLiving || ""}
                                        onChange={handleChange}
                                        rows="4"
                                        style={{ height: "120px" }}
                                    />
                                    <label>My most important reason for living</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* All Modals */}
                <div className="modal fade" id="step1Modal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Step 1: Warning Signs
                                </small>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Warning signs (thoughts, images, mood, situation, behavior) that a crisis may be developing:</strong></p>
                                <p>List personal triggers such as specific thoughts, mental images, moods, situations, or behaviors that indicate a crisis is starting.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="step2Modal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Step 2: Internal Coping Strategies
                                </small>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Internal coping strategies – Things I can do to take my mind off my problems without contacting another person:</strong></p>
                                <p>List activities like exercise, listening to music, journaling, deep breathing, etc., that help calm you independently.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="step3Modal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Step 3: Social Distraction
                                </small>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>People and social settings that provide distraction:</strong></p>
                                <p>List names of people or safe places (e.g., coffee shop, mosque, park) where being around others can help distract and ground you.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="step4Modal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Step 4: People for Help
                                </small>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>People whom I can ask for help:</strong></p>
                                <p>List trusted family members, friends, or support persons you can reach out to when coping strategies aren't enough.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="step5Modal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Step 5: Professional Help
                                </small>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Professionals or agencies I can contact during a crisis:</strong></p>
                                <p>List clinicians, crisis hotlines, emergency services, or local mental health services with phone numbers and addresses.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="step6Modal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4 text-center mb-4">
                                    Step 6: Safe Environment
                                </small>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Making the environment safe:</strong></p>
                                <p>List specific steps to remove or restrict access to potentially harmful items or situations.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SafetyPlanForm;